<template>
  <div>
    <section id="previewContainer">
      <div id="myPreviewVideo">
      </div>
      <div
          id="select-devices">
        <div>
          <label>Camera</label>
          <b-form-select
              v-model="selectedVideo"
              :options="optsVideo"
          />
        </div>
      </div>
      <br />
    </section>
  </div>
</template>

<script>
import { PreviewPublisher } from "@vonage/video-express";
export default {
  name: "Sessions_Stage_Settings_Modal",
  components: {},
  props: {
    session: {
      type: Object,
      default: () => {}
    },
    profile: {
      type: Object,
      default: () => {}
    },
    avResources: {
      type: Object,
      default: () => {}
    },
  },
  mounted() {
    this.handleStartPreview();
  },
  computed: {
  },
  methods: {
    /* PREVIEWING*/
    handleStartPreview() {
      this.previewPublisher = new PreviewPublisher("previewContainer");
      let pubProps = {
        resolution: "1280x720",
        [this.selectedAudio === "" ? "publishAudio" : "audioSource"]:
            this.selectedAudio === "" ? false : this.selectedAudio,
        [this.selectedVideo === "" ? "publishVideo" : "videoSource"]:
            this.selectedVideo === "" ? false : this.selectedVideo,
        mirror: false,
        audioBitrate: 15,
        audioFallbackEnabled: true
      };
      this.previewPublisher.previewMedia({
        targetElement: "myPreviewVideo",
        publisherProperties: pubProps
      });
    },
  },
  data() {
    return {
      optsVideo: this.avResources && this.avResources.optsVideo ?  this.avResources.optsVideo : [],
      selectedVideo:  this.avResources && this.avResources.selectedVideo ?  this.avResources.selectedVideo :
          null,
      previewPublisher: null,
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
